import React from 'react'
import classes from './common.module.scss'

const Label = (props: any) => <label className={classes.label} {...props} />

export default Label
